// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.x-ProgressBar-stepContainer {
  padding: 5px 5px;
  margin-top: 10px;
}
.x-ProgressBar-stepTitle {
  margin: 0;
}
.x-ProgressBar-text {
  margin: 0;
}
.x-ProgressBar-textContainer {
  padding-left: 30px;
}
.x-ProgressBar-mouseHover :hover {
  cursor: pointer;
  color: #00abdd;
}
.x-ProgressBar-mouseHoverNoColor :hover {
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./modules/portal-core/components/ProgressBar.less"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,gBAAA;AACF;AAEA;EACE,SAAA;AAAF;AAGA;EACE,SAAA;AADF;AAIA;EACE,kBAAA;AAFF;AAKA;EAEI,eAAA;EACA,cAAA;AAJJ;AAQA;EAEI,eAAA;AAPJ","sourcesContent":[".stepContainer {\n  padding: 5px 5px;\n  margin-top: 10px;\n}\n\n.stepTitle {\n  margin: 0;\n}\n\n.text {\n  margin: 0;\n}\n\n.textContainer {\n  padding-left: 30px;\n}\n\n.mouseHover {\n  :hover {\n    cursor: pointer;\n    color: #00abdd;\n  }\n}\n\n.mouseHoverNoColor {\n  :hover {\n    cursor: pointer;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stepContainer": `x-ProgressBar-stepContainer`,
	"stepTitle": `x-ProgressBar-stepTitle`,
	"text": `x-ProgressBar-text`,
	"textContainer": `x-ProgressBar-textContainer`,
	"mouseHover": `x-ProgressBar-mouseHover`,
	"mouseHoverNoColor": `x-ProgressBar-mouseHoverNoColor`
};
export default ___CSS_LOADER_EXPORT___;
